import React, {useEffect, useState} from 'react';
import moment from "moment/moment";

// Components
import SurveyForm from "./components/UserSurvey/SurveyForm.js";

const SpecificSurvey = ({ selectedSurvey }) => {
    const [editable, SetEditable] = useState(false);

    const dateIsBefore = moment().isBefore(moment(selectedSurvey?.survey_deadline));
    const dateIsAfter = moment().isAfter(moment(selectedSurvey?.survey_period_starts));

    useEffect(() => {
        if (dateIsBefore && dateIsAfter) {
            SetEditable(true);
        } else {
            SetEditable(false);
        }
    }, []);

    const surveyProps = {
        surveyData: selectedSurvey,
        editable: editable,
    };

    return (
        <SurveyForm {...surveyProps}/>
    );
}

export default React.memo(SpecificSurvey);
